<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 col-gap-12 row-gap-11 items-center">
    <BaseInput v-model.trim="$v.title.$model"
               :label="$t('titleLabel')"
               :class="{'--error':$v.title.$error }">
      <template v-slot:errors="">
        <div class="error" v-if="!$v.title.required">{{ $t('errors.required') }}</div>
        <div class="error" v-else-if="!$v.title.noSpecSymbols">{{ $t('errors.noSpecSymbols') }}</div>
      </template>
    </BaseInput>
    <BaseButton theme="red"
                class="col-start-1 w-78 lg:w-91 mr-8"
                :loading="submitted"
                @click="add">
      {{ $t('createLabel') }}
    </BaseButton>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {helpers, required} from "vuelidate/lib/validators";
import BaseButton from "@/components/UI/BaseButton";
import BaseInput from "@/components/UI/BaseInput/BaseInput";

const noSpecSymbols = helpers.regex('noSpecSymbols', /^[^*|\/":<>[\]{}`\\()';@&!$]+$/)

export default {
  name: "TagsSettingsForm",
  components: {BaseInput, BaseButton},
  data() {
    return {
      title: '',
      submitted: false
    }
  },
  computed: {
    ...mapState('space', ['current_space']),
  },
  validations: {
    title: {
      required,
      noSpecSymbols
    }
  },
  methods: {
    ...mapActions('space/tags', ['createTag']),
    async add() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          this.submitted = true;
          const tag = {title: this.title, space_id: this.current_space.data.id};
          const res = await this.createTag(tag);
          if (res.body.success) {
            this.afterSuccess();
            this.$toasted.success(this.$t('successMessage'))
            this.$store.commit('space/tags/pushTag', res.body.data);
          }
        } catch (err) {
          console.error(err)
        } finally {
          this.submitted = false;
        }
      }
    },
    afterSuccess() {
      this.title = '';
      this.$v.$reset();
    }
  },
  i18n: {
    messages: {
      en: {
        titleLabel: 'Name',
        createLabel: 'Create tag',
        successMessage: 'Successfully created tag'
      },
      ru: {
        titleLabel: 'Название',
        createLabel: 'Создать тег',
        successMessage: 'Тег создан'
      }
    }
  }
}
</script>

<style scoped>

</style>